import React from 'react';

import {EntitlementsPagination} from 'src/modules/entitlements';

import {mcpUserEntitlementsStateActions, mcpUserEntitlementsStateSelector} from '../slices/mcp-user-entitlements-state.slice';

type Props = {
    totalCount: number,
};

export const McpUserEntitlementsPagination = ({totalCount}: Props) => (
    <EntitlementsPagination
        totalCount={totalCount}
        stateActions={mcpUserEntitlementsStateActions}
        stateSelector={mcpUserEntitlementsStateSelector}
    />
);
